import { Tooltip2 } from '@blueprintjs/popover2'
import { useNavigate } from '@reach/router'
import { Icon } from '@ui'
import React from 'react'
import css from 'components/EmployeeManagement/locationFilterNote.module.scss'

const LocationFilterNote: React.FC = () => {
  const navigate = useNavigate()

  return (
    <Tooltip2
      placement="bottom"
      hoverCloseDelay={2000}
      content={
        <>
          Location filter applied. Check your
          <a
            href="/company_settings/user"
            onClick={(e) => {
              e.preventDefault()
              navigate?.('/company_settings/user', {})
            }}
            className={css.link}>
            <u>settings</u>
          </a>
          page.
        </>
      }>
      <Icon name="fa-thin fa-circle-exclamation" className={css.alert} />
    </Tooltip2>
  )
}

export default LocationFilterNote
